"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import React from "react";
import { action, computed, observable, runInAction, toJS } from "mobx";
import { observer } from "mobx-react";
import Tooltip, { TooltipSize } from "../Tooltip/Tooltip";
import ErrorTooltip from "../Tooltip/ErrorTooltip";
import TextInput, { TextInputType } from "../TextInput/TextInput";
import Dropdown from "../dropdown/Dropdown/Dropdown";
import DropdownItem from "../dropdown/DropdownItem/DropdownItem";
import { RadioGroup, RadioGroupItem } from "../RadioGroup/RadioGroup";
import Button from "../Button/Button";
import classNames from "classnames";
import { OptionGroupSize, StricterOptionGroup } from "../OptionGroup/OptionGroup";
import {
  FormType,
  FormWidth,
  FormInputSize
} from "./Types";
export { FormType, FormWidth, FormInputSize } from "./Types";
const DEFAULT_TEXT_INPUT_MAX_LENGTH = 1e3;
let Form = class extends React.Component {
  constructor(props) {
    super(props);
    this.dropdownValues = {};
    this.textValues = {};
    this.radioValues = {};
    this.optionValues = {};
    this.shouldShowError = false;
    this.submitCount = 0;
    this.isSubmitting = false;
    this.externalError = "";
    this.getDropdownValue = (field) => {
      var _a, _b, _c;
      const dropdownState = this.getDropdownState(field);
      return (_c = (_b = dropdownState.otherText) != null ? _b : (_a = dropdownState.option) == null ? void 0 : _a.id) != null ? _c : "";
    };
    this.getDropdownState = (field) => {
      const otherOption = field.options.find((option) => option.isOtherOption);
      if (this.props.dataStore) {
        const externalValue = this.getValue(field.id);
        if (!!externalValue) {
          const externalOption = field.options.find((option) => option.id === externalValue);
          if (externalOption) {
            return { option: externalOption };
          }
          if (!externalOption && otherOption) {
            return { option: otherOption, otherText: externalValue };
          }
          if (!externalOption && !otherOption) {
            return {};
          }
        }
        if (!externalValue) {
          const internalValue2 = this.getValue(field.id, FormType.Dropdown, true);
          const internalOption2 = field.options.find((option) => option.id === internalValue2);
          if (internalOption2 && internalOption2 === otherOption) {
            return { option: internalOption2, otherText: "" };
          }
          return {};
        }
      }
      const internalValue = this.getValue(field.id, FormType.Dropdown, true);
      const internalOtherValue = this.getValue(field.id, FormType.Text, true);
      const internalOption = field.options.find((option) => option.id === internalValue);
      if (internalOption && internalOption !== otherOption) {
        return { option: internalOption };
      }
      if (internalOption && internalOption === otherOption) {
        return { option: internalOption, otherText: internalOtherValue };
      }
      return {};
    };
    this.isSubmitKeyEvent = (event) => {
      const nodeName = event.target.nodeName;
      return event.key == "Enter" && nodeName.toLowerCase() != "textarea";
    };
    this.maybeSubmit = (event) => {
      if (this.isSubmitKeyEvent(event) && !this.isSubmitting) {
        if (this.props.allowDevAutocomplete) {
          for (let i = 0; i < this.props.fields.length; i++) {
            const field = this.props.fields[i];
            if (field.type === FormType.Text) {
              if (!this.getValue(field.id, field.type)) {
                if (field.props.type === TextInputType.Email) {
                  this.setValue(field.type, field.id, getRandomEmail(field.props.placeholder || ""));
                } else {
                  this.setValue(field.type, field.id, field.props.placeholder || "");
                }
              }
            } else if (field.type === FormType.OptionGroup) {
              if (!this.getValue(field.id, field.type)) {
                this.setValue(field.type, field.id, field.props.options[0].value);
              }
            } else if (field.type === FormType.Radio) {
              if (!this.getValue(field.id, field.type)) {
                this.setValue(field.type, field.id, field.props.options[0].value);
              }
            } else {
              if (!this.getValue(field.id, field.type) && field.options) {
                this.setValue(field.type, field.id, field.options[0].id);
              }
            }
          }
        }
        this.onSubmit();
      }
    };
  }
  componentDidMount() {
    if (this.props.showEnterKeyPrompt) {
      window.document.addEventListener("keyup", this.maybeSubmit);
    }
  }
  componentWillUnmount() {
    if (this.props.showEnterKeyPrompt) {
      window.document.removeEventListener("keyup", this.maybeSubmit);
    }
  }
  setValue(fieldType, fieldId, value, { isOtherOption = false } = {}) {
    var _a;
    switch (fieldType) {
      case FormType.Text: {
        this.textValues[fieldId] = value;
        break;
      }
      case FormType.Dropdown: {
        this.dropdownValues[fieldId] = value;
        break;
      }
      case FormType.Radio: {
        this.radioValues[fieldId] = value;
        break;
      }
      case FormType.OptionGroup: {
        this.optionValues[fieldId] = value;
        break;
      }
    }
    if (this.props.dataStore) {
      if (isOtherOption) {
        this.props.dataStore.setById(fieldId, (_a = this.textValues[fieldId]) != null ? _a : "");
      } else {
        this.props.dataStore.setById(fieldId, value);
      }
    }
    if (this.shouldShowError) {
      this.shouldShowError = false;
    }
  }
  get values() {
    const values = {};
    this.props.fields.forEach((field) => {
      if (field.type === FormType.Dropdown) {
        values[field.id] = this.getDropdownValue(field);
      } else {
        values[field.id] = this.getValue(field.id, field.type);
      }
    });
    return values;
  }
  getValue(fieldId, fieldType, alwaysUseInternalValue) {
    if (this.props.dataStore && !alwaysUseInternalValue) {
      return this.props.dataStore.getById(fieldId);
    } else {
      return computed(() => {
        switch (fieldType) {
          case FormType.Text: {
            return this.safeGetValue(this.textValues, fieldId);
          }
          case FormType.Dropdown: {
            return this.safeGetValue(this.dropdownValues, fieldId);
          }
          case FormType.Radio: {
            return this.safeGetValue(this.radioValues, fieldId);
          }
          case FormType.OptionGroup: {
            return this.safeGetValue(this.optionValues, fieldId);
          }
          default: {
            return this.safeGetValue(this.textValues, fieldId) || this.safeGetValue(this.dropdownValues, fieldId) || this.safeGetValue(this.radioValues, fieldId) || this.safeGetValue(this.optionValues, fieldId) || "";
          }
        }
      }).get();
    }
  }
  safeGetValue(valuesStore, fieldId) {
    return valuesStore[fieldId] || "";
  }
  get isValid() {
    const { enableSubmission } = this.props;
    let isValid = true;
    const submissionAllowed = enableSubmission != null ? enableSubmission : true;
    for (const field of this.props.fields) {
      const value = field.type === FormType.Dropdown ? this.getDropdownValue(field) : this.getValue(field.id);
      const errorMessage = field.validate(value);
      isValid = isValid && !errorMessage;
    }
    return isValid && submissionAllowed;
  }
  get errorField() {
    let result;
    for (let i = 0; i < this.props.fields.length; i++) {
      const field = this.props.fields[i];
      const value = field.type === FormType.Dropdown ? this.getDropdownValue(field) : this.getValue(field.id);
      const errorMessage = field.validate(value);
      if (errorMessage) {
        result = field;
        break;
      }
    }
    return result;
  }
  render() {
    const { endElement } = this.props;
    const onFormKeyUp = !this.props.showEnterKeyPrompt ? this.maybeSubmit : void 0;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames("form form--kl", `form--${this.props.width}`, this.props.className),
        onKeyUp: onFormKeyUp
      },
      this.fields,
      !!endElement && endElement,
      !this.props.hideSubmitButton && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "form__button-spacer" }), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames("form__button-with-prompt", {
            "form__button-with-prompt--with-enter-key": this.props.showEnterKeyPrompt,
            "form__button-with-prompt--single-action": !this.props.showEnterKeyPrompt
          })
        },
        /* @__PURE__ */ React.createElement(
          ErrorTooltip,
          {
            renderTooltip: !!this.externalError,
            content: this.externalError || "",
            size: TooltipSize.Large
          },
          /* @__PURE__ */ React.createElement("div", { className: "form__button-wrapper", onMouseEnter: this.onMouseEnter }, /* @__PURE__ */ React.createElement(
            Button,
            {
              className: "form__button",
              onClick: this.onSubmit,
              size: this.props.inputSize,
              disabled: !this.isValid,
              "data-synthetics-selector": "form-button"
            },
            this.props.buttonText
          ))
        ),
        this.props.showEnterKeyPrompt && /* @__PURE__ */ React.createElement("div", { className: "form__enter-key" }, "or press \u2018Enter\u2019 key")
      ))
    );
  }
  get fields() {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.fields.map((field, index) => /* @__PURE__ */ React.createElement("div", { key: index, "data-fieldid": field.id }, this.renderField(field), index !== this.props.fields.length - 1 && /* @__PURE__ */ React.createElement("div", { className: "form__spacer" }))));
  }
  renderField(field) {
    var _a, _b;
    const value = field.type === FormType.Dropdown ? this.getDropdownValue(field) : this.getValue(field.id);
    const shouldShowError = this.shouldShowError && this.errorField && this.errorField.id == field.id;
    const errorMessage = field.validate(value) || "";
    if (field.type === FormType.Text) {
      return /* @__PURE__ */ React.createElement(Tooltip, { isError: true, content: errorMessage, size: TooltipSize.Large, show: shouldShowError }, this.renderTextInput(field));
    } else if (field.type === FormType.Dropdown) {
      const selectedId = (_b = (_a = this.getDropdownState(field).option) == null ? void 0 : _a.id) != null ? _b : "";
      const showOtherTextInput = isDropdownOtherSelected(selectedId, field) && field.showOtherTextInput;
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        Tooltip,
        {
          isError: true,
          content: errorMessage,
          size: TooltipSize.Large,
          show: !showOtherTextInput && shouldShowError
        },
        this.renderDropdown(field)
      ), isDropdownOtherSelected(selectedId, field) && field.showOtherTextInput && /* @__PURE__ */ React.createElement(Tooltip, { isError: true, content: errorMessage, size: TooltipSize.Large, show: shouldShowError }, this.renderDropdownOtherTextInput(field)));
    } else if (field.type === FormType.Radio) {
      return /* @__PURE__ */ React.createElement(Tooltip, { isError: true, content: errorMessage, size: TooltipSize.Large, show: shouldShowError }, this.renderRadioGroup(field));
    } else if (field.type === FormType.OptionGroup) {
      return /* @__PURE__ */ React.createElement(Tooltip, { isError: true, content: errorMessage, size: TooltipSize.Large, show: shouldShowError }, this.renderOptionGroup(field));
    }
  }
  renderTextInput(field) {
    var _a;
    return /* @__PURE__ */ React.createElement(
      TextInput,
      __spreadProps(__spreadValues({
        size: this.props.inputSize
      }, field.props), {
        value: this.getValue(field.id),
        onChange: (value) => {
          this.setValue(field.type, field.id, value);
        },
        maxLength: (_a = field.maxTextInputLength) != null ? _a : DEFAULT_TEXT_INPUT_MAX_LENGTH
      })
    );
  }
  renderDropdown(field) {
    var _a, _b;
    const dropdownName = (_b = (_a = this.getDropdownState(field).option) == null ? void 0 : _a.name) != null ? _b : "";
    return /* @__PURE__ */ React.createElement(
      Dropdown,
      __spreadProps(__spreadValues({
        size: this.props.inputSize
      }, field.props), {
        name: dropdownName
      }),
      (field.options || []).map((option, index) => /* @__PURE__ */ React.createElement(
        DropdownItem,
        {
          key: index,
          name: option.name,
          selected: dropdownName === option.name,
          onSelect: () => {
            this.setValue(FormType.Dropdown, field.id, option.id, { isOtherOption: option.isOtherOption });
          }
        }
      ))
    );
  }
  renderDropdownOtherTextInput(field) {
    var _a, _b;
    return /* @__PURE__ */ React.createElement(
      TextInput,
      __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, field.props), {
        labelHidden: true,
        label: "Other",
        size: this.props.inputSize
      }), field.otherTextInputProps), {
        className: "form__other-for-dropdown",
        value: (_a = this.getDropdownState(field).otherText) != null ? _a : "",
        onChange: (value) => {
          this.setValue(FormType.Text, field.id, value);
        },
        maxLength: (_b = field.maxTextInputLength) != null ? _b : DEFAULT_TEXT_INPUT_MAX_LENGTH
      })
    );
  }
  renderRadioGroup(field) {
    return /* @__PURE__ */ React.createElement(
      RadioGroup,
      __spreadProps(__spreadValues({}, field.props), {
        value: this.getValue(field.id),
        onChange: (value) => {
          this.setValue(field.type, field.id, value);
        }
      }),
      field.props.options.map((option) => /* @__PURE__ */ React.createElement(RadioGroupItem, { key: option.value, label: option.label, value: option.value, disabled: option.disabled }))
    );
  }
  renderOptionGroup(field) {
    return /* @__PURE__ */ React.createElement(
      StricterOptionGroup,
      __spreadProps(__spreadValues({}, field.props), {
        size: OptionGroupSize.Large,
        selectedValue: this.getValue(field.id, FormType.OptionGroup),
        onClickHandler: (value) => {
          this.setValue(field.type, field.id, value);
        }
      })
    );
  }
  onSubmit() {
    return __async(this, null, function* () {
      if (this.isSubmitting) {
        return;
      } else if (this.isValid) {
        try {
          this.setIsSubmitting(true);
          this.externalError = "";
          yield this.props.onComplete(toJS(this.values));
        } catch (error) {
          this.externalError = error.message;
          throw error;
        } finally {
          this.setIsSubmitting(false);
        }
      } else {
        this.showError();
        throw new Error();
      }
    });
  }
  setIsSubmitting(isSubmitting) {
    this.isSubmitting = isSubmitting;
  }
  onMouseEnter() {
    return __async(this, null, function* () {
      if (!this.isValid) {
        this.showError();
      }
    });
  }
  showError() {
    const submitCount = ++this.submitCount;
    this.shouldShowError = true;
    setTimeout(() => {
      runInAction(() => {
        if (this.submitCount === submitCount) {
          this.shouldShowError = false;
        }
      });
    }, 3500);
  }
};
Form.defaultProps = {
  width: FormWidth.Normal,
  allowDevAutocomplete: false,
  buttonText: "Submit",
  showEnterKeyPrompt: false,
  inputSize: FormInputSize.Large
};
__decorateClass([
  observable.deep
], Form.prototype, "dropdownValues", 2);
__decorateClass([
  observable.deep
], Form.prototype, "textValues", 2);
__decorateClass([
  observable.deep
], Form.prototype, "radioValues", 2);
__decorateClass([
  observable.deep
], Form.prototype, "optionValues", 2);
__decorateClass([
  observable.ref
], Form.prototype, "shouldShowError", 2);
__decorateClass([
  observable.ref
], Form.prototype, "submitCount", 2);
__decorateClass([
  observable.ref
], Form.prototype, "isSubmitting", 2);
__decorateClass([
  observable.ref
], Form.prototype, "externalError", 2);
__decorateClass([
  action.bound
], Form.prototype, "setValue", 1);
__decorateClass([
  computed
], Form.prototype, "values", 1);
__decorateClass([
  computed
], Form.prototype, "isValid", 1);
__decorateClass([
  computed
], Form.prototype, "errorField", 1);
__decorateClass([
  computed
], Form.prototype, "fields", 1);
__decorateClass([
  action.bound
], Form.prototype, "onSubmit", 1);
__decorateClass([
  action.bound
], Form.prototype, "setIsSubmitting", 1);
__decorateClass([
  action.bound
], Form.prototype, "onMouseEnter", 1);
__decorateClass([
  action.bound
], Form.prototype, "showError", 1);
Form = __decorateClass([
  observer
], Form);
const getRandomEmail = (baseEmail) => {
  return baseEmail.replace(/@.+$/, `${Math.floor(Math.random() * 99999999)}@testing.com`);
};
const isDropdownOtherSelected = (selectedValue, field) => {
  var _a;
  return !!((_a = field.options.find((f) => f.id === selectedValue)) == null ? void 0 : _a.isOtherOption);
};
export default Form;
